"use client";

import { useCallback, useState } from "react";
import { useSearchParams, usePathname } from "next/navigation";
import { z } from "zod";
import _ from "lodash";
import qs from "qs";
//@ts-ignore
import * as _l from "lodash-contrib";
import { useRouter } from "nextjs-toploader/app";

function clean(obj: any) {
  for (var propName in obj) {
    if (_.isObject(obj[propName])) {
      clean(obj[propName]);
    }
    if (obj[propName] === null || obj[propName] === undefined || (_.isObject(obj[propName]) && _.isEmpty(obj[propName]))) {
      delete obj[propName];
    }
  }
}

interface UseQueryParamsConfig<T extends z.ZodTypeAny> {
  schema: T;
  defaultValues: z.infer<T>;
  scroll?: boolean;
  replace?: boolean;
}

export function useQueryParams<T extends z.ZodTypeAny>(
  config: UseQueryParamsConfig<T>,
): {
  queryParams: z.infer<T>;
  setQueryParams: (newParams: Partial<z.infer<T>>, scroll?: boolean) => void;
  getPath: (newParams: Partial<z.infer<T>>) => string;
} {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  // Convert URLSearchParams to an object
  // const searchParamsObject = Object.fromEntries(searchParams.entries());
  const result = qs.parse(searchParams.toString());
  const initialParse = config.schema.safeParse({
    ...config.defaultValues,
    ...result,
  });
  const queryParams = initialParse.success ? initialParse.data : config.defaultValues;
  const getPath = (newParams: Partial<z.infer<T>>): string => {
    const result = qs.parse(searchParams.toString());
    const initialParse = config.schema.safeParse({
      ...config.defaultValues,
      ...result,
    });
    const queryParams = initialParse.success ? initialParse.data : config.defaultValues;
    const mergedParams = { ...queryParams, ...newParams };
    const parsedQuery = config.schema.safeParse(mergedParams);
    if (parsedQuery.success) {
      const newObj = _.pickBy(parsedQuery.data, _.identity);

      clean(newObj);

      const query = _l.toQuery(newObj);

      return `${pathname}?${query}`;
    } else {
      console.error("Validation failed:", parsedQuery.error);
      return pathname;
    }
  };
  const setQueryParams = (newParams: Partial<z.infer<T>>, scroll?: boolean) => {
    const path = getPath(newParams);

    if (config.replace) {
      router.replace(`${path}`, { scroll: scroll ?? config.scroll ?? true });
    } else {
      router.push(`${path}`, { scroll: scroll ?? config.scroll ?? true });
    }
  };
  // const setQueryParams = useCallback((newParams: Partial<z.infer<T>>) => {

  let x = queryParams;
  clean(x);

  return {
    queryParams: x,
    setQueryParams,
    getPath,
  };
}
